import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { GetSchedulePostParams, ResponseGetSchedulePost, PostsEndpoints } from 'src/services/posts'
import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { REQUEST_CONFIG } from './useGetScheduledPost.constants'

export const useGetScheduledPost = (params: GetSchedulePostParams) => {
  const { communityId, postId, isEnabled } = params
  const url = PostsEndpoints.getSchedulePost(postId)

  return useHotRequest<ResponseGetSchedulePost>(url, {
    cacheKey: [url],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_SPARKLE,
    params: { communityId },
    queryOptions: {
      enabled: Boolean(isEnabled),
      ...REQUEST_CONFIG
    }
  })
}
